import { base_url } from "Backend/api";

export const registerFcmToken = async (fcmToken, authToken) => {

  try {

    const response = await fetch(`${base_url}/api/notifications/register-token`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${authToken}`,
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        fcm_token: fcmToken
      })
    });

    const data = await response.json();

    console.log("FCM Register:", data);

  } catch (e) {
    console.log("Register error:", e);
  }
};